import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const ClientPortalOnboardingActionsQuery = graphql(`
  query ClientPortalOnboardingActions($householdId: ID) {
    tasks(household: true, householdId: $householdId) {
      id
      type
      status
      onboardingTask {
        coClientDocusignSignedAt
        coClientIaaSignedAt
        primaryClientDocusignSignedAt
        primaryClientIaaSignedAt
      }
      user {
        isPrimaryClient
      }
    }
  }
`);

export type ClientPortalOnboardingActionsResult = ResultOf<typeof ClientPortalOnboardingActionsQuery>;

export type ClientPortalOnboardingActionTask = NonNullable<ClientPortalOnboardingActionsResult['tasks']>[number];
